import React, { useState, useEffect } from 'react'
import { COLORES } from '../../../../config/colores'

function RechazadoEnBruto (props) {
  const { motivo, cpe, borrarCpe, modo } = props
  const [seconds, setSeconds] = useState(15)

  useEffect(() => {
    const interval = setInterval(() => {
      if (modo === 'manual') {
        if (seconds > 0 && cpe && cpe.error) {
          setSeconds(seconds - 1)
        }
        if (seconds === 0) {
          borrarCpe(cpe.numero)
        }
      }
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  })

  return (
    <div
      style={{
        backgroundColor: COLORES.grey.dark,
        color: COLORES.grey.light,
        height: '100%',
        textAlign: 'center',
        margin: 'auto 0',
        padding: '22px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >

      <h1 style={{ color: COLORES.grey.light }}>{motivo}</h1>
      <h3 style={{ marginTop: '3%', color: COLORES.grey.light }}>Debe dirigirse nuevamente al calado para volver a pesar</h3>
    </div>
  )
}

export default RechazadoEnBruto
